import type { Optional } from '@festina-life/core'
import type { TreeNodeData } from '@festina-life/ui/listsAndTables'
import { Icon } from '@festina-life/ui/structure'

import { useNavigationParams } from '../../../system/useNavigationParams'
import { ConfigurationBranchStatus } from '../../branchNameWithStatus/ConfigurationBranchStatus'
import type { BranchLeaf } from '../types'
import { getBranchServerFromPath } from './helpers'

type Props = {
  node: TreeNodeData<BranchLeaf>
  label?: Optional<string>
}

export const BranchesTreeNode = ({ node, label }: Props) => {
  const { branch: viewingBranch, server: currentServer } = useNavigationParams()
  const branchServer = getBranchServerFromPath(node.path)

  const isCurrentBranch =
    branchServer === currentServer && node.name === viewingBranch
  const branchKey = { name: node.name, server: branchServer }

  return isCurrentBranch || node.tags.at(0) ? (
    <ConfigurationBranchStatus branchKey={branchKey} label={label} />
  ) : (
    <div className="flex items-center gap-x-1">
      <Icon name={node.path.length === 1 ? 'CircleStack' : 'Folder'} />
      {label ?? node.name}
    </div>
  )
}
